import { render, staticRenderFns } from "./getYQMsg.vue?vue&type=template&id=4a0f5f05&scoped=true&"
import script from "./getYQMsg.vue?vue&type=script&lang=js&"
export * from "./getYQMsg.vue?vue&type=script&lang=js&"
import style0 from "./getYQMsg.vue?vue&type=style&index=0&id=4a0f5f05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0f5f05",
  null
  
)

export default component.exports